import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {callTargetedAction} from 'client/framework';
import tooltipActions from 'sg/Tooltip/Tooltip.actions';
import Tooltip from 'sg/Tooltip/Tooltip.react';
import './flat-bar-chart.scss';

export default class FlatBarChart extends React.PureComponent {
  static propTypes = {
    data: ImmutablePropTypes.listOf(ImmutablePropTypes.map.isRequired),
    inline: PropTypes.bool,
    graphDescription: PropTypes.string,
    tooltipText: PropTypes.string,
    tiny: PropTypes.bool
  };

  constructor() {
    super();
    this.tooltipStoreName = `flat-bar-chart-tooltip--${uuid()}`;
  }

  toggleTooltip = () => {
    callTargetedAction({
      name: tooltipActions.TOGGLE_VISIBILITY,
      targetStore: this.tooltipStoreName
    });
  };

  makeFlatChart = () => {
    const graphDescription = this.props.graphDescription ? (
      <h5 className='flat-bar-chart__graph-description'>{this.props.graphDescription}</h5>
    ) : null;

    const tooltip = this.props.tooltipText ? (
      <Tooltip position='top' storeName={this.tooltipStoreName}>
        <span>{this.props.tooltipText}</span>
      </Tooltip>
    ) : null;

    return (
      <div>
        <div
          className={classnames('flat-bar-chart__graph', {
            'flat-bar-chart__graph--active-tooltip': this.props.tooltipText,
            'flat-bar-chart__graph--tiny': this.props.tiny
          })}
          onClick={tooltip ? this.toggleTooltip : () => {}}
        >
          {this.props.data.map((datum, key) => {
            return (
              <div
                key={key}
                className={datum.get('fillColorClass')}
                style={{width: `${datum.get('fillPercentage')}%`}}
              />
            );
          })}
        </div>
        {graphDescription}
        {tooltip}
      </div>
    );
  };

  makeFlatChartKey = () => {
    if (this.props.inline || this.props.tiny) {
      return null;
    }
    return (
      <div className='flat-bar-chart__key'>
        {this.props.data.map((datum, key) => {
          return (
            <div key={key} className='flat-bar-chart__key-entry'>
              <div className={`flat-bar-chart__key-entry-swatch ${datum.get('fillColorClass')}`} />
              <div className='flat-bar-chart__key-entry-label'>{datum.get('keyLabel')}</div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <div className='flat-bar-chart'>
        {this.makeFlatChart()}
        {this.makeFlatChartKey()}
      </div>
    );
  }
}
